import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { dynamicBaseQuery } from '~/api/common/dynamicBaseQuery';
import { StageStatistics } from '~/api/models/stageStatistics';
import { CampaignStatistics } from '~/api/models/campaignStatistics';
import { PageQuery } from '~/api/models/PageQuery';
import { StageDeviceFilterCriteria } from '~/api/models/StageDeviceFilterCriteria';
import { PageStageDevices } from '~/api/models/PageStageDevices';

export const campaignStatisticsApi = createApi({
    reducerPath: 'campaignStatisticsApi',
    baseQuery: dynamicBaseQuery,
    tagTypes: ['CampaignStatistics'],
    endpoints: (builder) => ({
        getCampaignDeviceInfo: builder.mutation<PageStageDevices, {
            campaignId?: number;
            filterCriteria: StageDeviceFilterCriteria & PageQuery
        }>({
            query: ({ campaignId, filterCriteria }) => {
                const { pageNumber, pageSize, ...criteria } = filterCriteria;
                return {
                    url: `v1/admin/campaign-statistics/device-info/${campaignId}?page=${pageNumber}&size=${pageSize}`,
                    method: 'POST',
                    body: { ...criteria },
                };
            },
        }),
        getStageStatistics: builder.query<StageStatistics, number>({
            query: (stageId) => ({
                url: `v1/admin/campaign-statistics/stage/${stageId}`,
                method: 'GET',
            }),
        }),
        getCampaignStatistics: builder.query<CampaignStatistics, number>({
            query: (campaignId) => ({
                url: `v1/admin/campaign-statistics/campaign/${campaignId}`,
                method: 'GET',
            }),
        }),
    })
});

export const {
    useGetStageStatisticsQuery,
    useGetCampaignDeviceInfoMutation,
    useGetCampaignStatisticsQuery,
    useLazyGetStageStatisticsQuery,
} = campaignStatisticsApi;
